import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { Status } from '~/components/fields/StatusField';

function statusCell<T = any>(getStatus?: (record: T) => Status | ''): ColumnsType<T>[0] {
  return {
    title: '',
    dataIndex: 'status',
    render: (status: string, record) => (
      <div
        className={`StatusCellContent status-background__${getStatus ? getStatus(record) : status}`}
      />
    ),
    width: 4,
    className: 'StatusCell',
  };
}

export default statusCell;
